import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyOrderList = {
  // 酒店订单列表
  getHotelList(params) {
    return http.post(`${baseUrl}Company/hotelList`, params)
  },
  // 酒店订单详情
  getHotelDetail(params) {
    return http.post(`${baseUrl}Hotel/orderDetail`, params)
  },
  // 机票订单列表
  getPlaneList(params) {
    return http.post(`${baseUrl}Company/planeList`, params)
  },
  // 机票订单详情
  getPlaneDetail(params) {
    return http.post(`${baseUrl}Air/orderDetail`, params)
  },
  // 火车票订单列表
  getTrainList(params) {
    return http.post(`${baseUrl}Company/trainList`, params)
  },
  // 火车票订单详情
  getTrainDetail(params) {
    return http.post(`${baseUrl}Train/orderDetail`, params)
  },
  // 审核订单列表
  getExamineList(params) {
    return http.post(`${baseUrl}ToExamine/ExamineList`, params)
  },

  // 获取审批策略
  getClassifiedData(params) {
    return http.get(`${baseUrl}ApprovalCenter/oaClassifiedData`, params)
  },
  // 获取OA表单列表
  getoaReviewList(params) {
    return http.post(`${baseUrl}OaApproval/oaReviewList`, params)
  },
  // 修改列表启用状态
  oaStatesEdit(params) {
    return http.post(`${baseUrl}OaApproval/oaStatesEdit`, params)
  },
  // 删除列表
  delOaStates(params) {
    return http.post(`${baseUrl}OaApproval/oaReviewDelete`, params)
  },
  // 新增编辑OA表单
  editOaReview(params) {
    return http.post(`${baseUrl}OaApproval/oaReviewEdit`, params)
  },
  // 用车列表
  getCarList(params) {
    return http.post(`${baseUrl}Company/carList`, params)
  },
  // 用车订单详情
  getCarDetail(params) {
    return http.post(`${baseUrl}Car/carOrderDetail`, params)
  },
  /*** *********      业务日志页面       ************/

  // 获取业务日志列表
  getlogList(params) {
    return http.post(`${baseUrl}Bizlog/logList`, params)
  },
  // 套餐列表
  setMealOrderList(params) {
    return http.post(`${baseUrl}Package/setMealOrderList`, params)
  },
}



// WEBPACK FOOTER //
// ./src/api/companyOrderList.js